<template>
  <section
    class="youyan-start-right-now"
    :class="{ retractable: retractable }"
    data-buried="StartRightNow"
  >
    <div class="youyan-start-right-now__container">
      <Resource :src="BgAvatar" class="youyan-start-right-now__avatar" />
      <div class="youyan-start-right-now__content">
        <h2 class="youyan-start-right-now__title">
          {{ title }}
        </h2>
        <p v-if="desc" class="youyan-start-right-now__desc">
          {{ desc }}
        </p>
        <div class="youyan-start-right-now__operation">
          <StartBtn v-if="primaryBtnText" :handler="handler" :text="primaryBtnText" />
          <BookBtn v-if="secondaryBtnText" :code="code" :text="secondaryBtnText" />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import Resource from '~/components/resource/index';
import BookBtn from '~/design/components/buttons/book-btn.vue';
import StartBtn from '~/design/components/buttons/start-btn.vue';
import { transformImage } from '~/utils/';
import { getFeUrl } from '~/utils/url';

withDefaults(
  defineProps<{
    handler: () => void;
    retractable?: boolean;
    code?: number;
    title?: string;
    desc?: string;
    primaryBtnText?: string;
    secondaryBtnText?: string;
  }>(),
  {
    retractable: true,
    code: 1078924,
    title: '即刻开启你的3D数字人AI视频创作',
    primaryBtnText: '免费试用',
    secondaryBtnText: '企业咨询',
  },
);

const BgAvatar = transformImage(
  getFeUrl('/youyan-platform/main/start-right-now/convert-2.png?x-oss-process=image/format,webp'),
);
</script>

<style lang="scss" scoped src="./cn-styles/pc.scss" />
<style lang="scss" scoped src="./cn-styles/mobile.scss" />
